module.exports = __webpack_public_path__ + "static/media/aquarius.65754d6b.svg";